const API_URL_BASE = '/api/alert';
const HEADERS_JSON = {
	'Accept': 'application/json',
	'Content-Type': 'application/json',
};

const handleFetch = (url, fetchOptions = {}, returnJson = true) => fetch(url, fetchOptions)
	.then((res) => {
		if (res.ok) {
			return returnJson ? res.json() : true;
		}

		throw Error('Something went wrong wile fetching');
	});

const getAll = () => {
	// IE11 seems to cache the URL and response hard, adding cache busting to prevent this
	const cb = new Date().getTime();

	return handleFetch(`/api/alertsoverview/all?cb=${cb}`, { method: 'GET', headers: HEADERS_JSON }, true);
};

const get = id => handleFetch(`${API_URL_BASE}/get/${id}`, { method: 'GET', headers: HEADERS_JSON }, false);
const add = body => handleFetch(`${API_URL_BASE}/update`, { method: 'POST', body, headers: HEADERS_JSON }, false);
const update = body => handleFetch(`${API_URL_BASE}/update`, { method: 'PUT', body, headers: HEADERS_JSON }, false);
const remove = alertId => handleFetch(`${API_URL_BASE}/delete/${alertId}`, { method: 'DELETE' }, false);

export {
	getAll,
	get,
	update,
	add,
	remove,
};
